const gcp_appengine_id = 'smart-operator-dev'
const gcp_storage_endpoint = `https://storage.googleapis.com/${gcp_appengine_id}.appspot.com/`
const orchestration_context = '/sopservices/orch/v1'
const hide_other_login_options: boolean = false

export const environment = {
  production: true,
  // Relative: the API is served on the portal's own hostname, so one build works on any hostname (beta and real).
  baseUrl: orchestration_context,
  gcp_storage_endpoint,
  token_prefix: '[sop-portal-staging]',
  sopAdminPortalLink: 'https://admin-portal.stage.smartoperator.co/login',
  hide_other_login_options
}
